import { render, staticRenderFns } from "./StorageIndex.vue?vue&type=template&id=817c2b82&scoped=true&"
import script from "./StorageIndex.vue?vue&type=script&lang=js&"
export * from "./StorageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817c2b82",
  null
  
)

export default component.exports